import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import { api, type PublicBrand } from "@/api/client";

const Ctx = createContext<PublicBrand | null>(null);

function hexToRgbTriplet(hex: string | undefined, fallback: string): string {
  if (!hex || !/^#?[0-9a-f]{6}$/i.test(hex)) return fallback;
  const h = hex.replace("#", "");
  return `${parseInt(h.slice(0, 2), 16)} ${parseInt(h.slice(2, 4), 16)} ${parseInt(h.slice(4, 6), 16)}`;
}

export function BrandProvider({ children }: { children: ReactNode }) {
  const [brand, setBrand] = useState<PublicBrand | null>(null);
  useEffect(() => {
    const override = new URLSearchParams(location.search).get("brand");
    api<PublicBrand>(`/public/brand${override ? `?brand=${override}` : ""}`)
      .then((b) => {
        setBrand(b);
        const root = document.documentElement.style;
        root.setProperty("--brand-primary", hexToRgbTriplet(b.theme.primary, "233 30 99"));
        root.setProperty("--brand-accent", hexToRgbTriplet(b.theme.accent, "17 24 39"));
        document.title = b.name.el ?? b.name.en ?? "STUDIO";
      })
      .catch(() => setBrand(null));
  }, []);
  return <Ctx.Provider value={brand}>{children}</Ctx.Provider>;
}

export const useBrand = () => useContext(Ctx);
